<template>
  <div
    :class="{ 'scrollable-container' : isMobile }"
    class="container-resume"
  >
    <div class="data-person-page">
      <section
        v-if="validInit"
        class="section-profile-cover my-0"
      />
      <section
        v-if="!alert.show"
        class="section section-skew resume-form"
      >
        <div class="container">
          <card
            v-if="validInit"
            shadow
            class="card-profile mt--300"
            no-body
          >
            <div class="px-4">
              <div class="text-center mt-5">
                <h3>Preencha seus dados cadastrais:</h3>
                <div class="h6 font-weight-300"><i class="ni location_pin mr-2" />Lembresse de preencher corretamente as informações.</div>
              </div>
              <div class="mt-5 py-5 border-top text-center">
                <div class="row justify-content-center">
                  <div class="col-lg-9">
                    <div>
                      <b-steps
                        v-model="activeStep"
                        :has-navigation="false"
                        size="is-small"
                        type="is-info"
                      >
                        <b-step-item
                          :clickable="false"
                          label="Dados Cadastrais"
                          icon="account-key"
                          class="custom-step-item"
                        />
                        <b-step-item
                          label="Dados de Endereço"
                          icon="account"
                          class="custom-step-item"
                        />
                      </b-steps>
                    </div>
                    <form
                      id="address-form"
                      @submit="sendValidation"
                    >
                      <base-input
                        v-model="$v.form.zipCode.$model"
                        v-mask="'#####-###'"
                        :masked="false"
                        :valid="form.zipCode.length && !$v.form.zipCode.$invalid"
                        @blur="fetchAddress"
                        type="tel"
                        alternative
                        placeholder="CEP"
                        title="cep"
                        addon-left-icon="ni ni-pin-3"
                      />
                      <base-input
                        v-model="$v.form.address.$model"
                        :valid="form.address.length && !$v.form.address.$invalid"
                        alternative
                        class="mb-3"
                        placeholder="Endereço"
                        title="endereço"
                        addon-left-icon="ni ni-square-pin"
                      />
                      <base-input
                        v-model="$v.form.complement.$model"
                        :valid="form.complement.length && !$v.form.complement.$invalid"
                        alternative
                        class="mb-3"
                        placeholder="Complemento"
                        title="complemento"
                        addon-left-icon="ni ni-ungroup"
                      />
                      <base-input
                        v-model="$v.form.state.$model"
                        :valid="form.state.length && !$v.form.state.$invalid"
                        alternative
                        class="mb-3"
                        placeholder="Estado"
                        title="estado"
                        addon-left-icon="ni ni-building"
                      />
                      <base-input
                        v-model="$v.form.city.$model"
                        :valid="form.city.length && !$v.form.city.$invalid"
                        alternative
                        class="mb-3"
                        placeholder="Cidade"
                        title="cidade"
                        addon-left-icon="ni ni-shop"
                      />
                      <div class="text-center">
                        <base-button
                          @click="sendValidation()"
                          type="submit"
                          class="btn btn-primary mb-3 mb-sm-0 my-4"
                        >Continuar validação</base-button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </card>
        </div>
      </section>
      <slide-y-up-transition v-if="alert.show">
        <div class="col-lg-12 text-center alert-message">
          <h1 class="display-3 ">
            {{ alert.title }}
          </h1>
          <div class="d-flex flex-column justify-space-between align-center">
            <div class="flex-item item">
              <img
                v-lazy="'img/icons/common/fail.png'"
                class="card-img"
              >
            </div>
          </div>
          <p>{{ alert.message }}</p>
          <base-button
            @click="alert.action()"
            class="btn btn-primary btn-error mb-3 mb-sm-0"
          >
            {{ alert.textButton }}
          </base-button>
        </div>
      </slide-y-up-transition>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { SlideYUpTransition } from 'vue2-transitions'
import { required, minLength } from 'vuelidate/lib/validators'
import { removeSpecialCharacters } from '@/utils'
import IncogniaWebSdk from '@incognia/web-sdk'

export default {
  name: 'ResumeView',
  components: {
    SlideYUpTransition
  },
  data() {
    return {
      validInit: false,
      fields: [],
      alert: {
        show: false,
        type: '',
        title: '',
        message: '',
        action: false,
        textButton: 'Reiniciar a validação'
      },
      form: {
        address: '',
        complement: '',
        zipCode: '',
        city: '',
        state: ''
      },
      activeStep: 1
    }
  },
  computed: {
    ...mapGetters([
      'device',
      'riskDevice',
      'riskDeviceId'
    ]),
    isMobile() {
      return this.device === 'mobile'
    }
  },
  created() {
    this.validStep()
    this.initRiskDevice()
  },
  validations: {
    form: {
      address: { required },
      complement: { },
      zipCode: { required, minLength: minLength(9) },
      city: { required },
      state: { required }
    }
  },
  methods: {
    ...mapActions([
      'validStepTransaction',
      'resetProcessUser',
      'getCEP',
      'addressTransaction'
    ]),
    async fetchAddress() {
      const cep = removeSpecialCharacters(this.form.zipCode)
      const { success, data } = await this.getCEP(cep)

      if (success && !data.data.erro) {
        this.form.address = data.data.logradouro
        this.form.complement = data.data.complemento
        this.form.state = data.data.uf
        this.form.city = data.data.localidade
      }
    },
    async validStep() {
      const { success, data } = await this.validStepTransaction({ step: 'resume' })
      if (success) {
        const { data: dataInit } = data

        this.validInit = true
        this.fields = dataInit.fields
      }
    },
    async sendValidation() {
      if (this.$v.form.$invalid) {
        this.success = false
        return this.$buefy.toast.open({
          duration: 5000,
          message: `Por favor, verifique os campos <b>obrigatórios</b>!`,
          position: 'is-top',
          type: 'is-danger'
        })
      }

      this.validTransactionStart()
    },
    async validTransactionStart() {
      const data = await this.addressTransaction({
        zipCode: removeSpecialCharacters(this.form.zipCode),
        address: this.form.address,
        complement: this.form.complement,
        state: this.form.state,
        city: this.form.city
      })

      if (data.success) {
        const { data: dataValid } = data.data

        const nextStep = dataValid.nextStep
        if (nextStep) {
          this.$router.push({
            name: nextStep
          })
        }
      } else {
        const erroData = data.error.data
        const { message: messageKey } = erroData

        this.alert = {
          show: true,
          type: 'danger',
          message: this.$t(`errors.${messageKey}`) || 'Não foi possível validar sua solicitação',
          textButton: 'Reiniciar a validação',
          action: () => {
            this.restartProcess()
          }
        }
      }
    },
    async restartProcess() {
      const link = await this.resetProcessUser()
      this.$router.push({
        path: '/',
        query: {
          y: link
        }
      })
    },
    initRiskDevice() {
      if (this.riskDevice) {
        IncogniaWebSdk.init({ appId: this.riskDeviceId })
      }
    }
  }
}
</script>
<style scoped lang="scss">
.scrollable-container {
  overflow-y: auto;
  max-height: 100vh;
}
.btn-error {
  margin-top: 15px;
}
@media (min-width: 768px) {
  .container-resume {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .scrollable-container {
    max-height: 100vh;
  }
}
</style>
